export const keyboardActionHandler = (event, action, key) => {
    // Prevent scrolling when space is pressed
    if (event.key === ' ') event.preventDefault();

    if (Array.isArray(key) && key.includes(event.key)) {
        action();
    } else if (event.key === key) {
        action();
    }
};
